module.exports = __webpack_public_path__ + "img/malware.cf9e1db6.png";